import FiltersModal from '@/components/modals/FiltersModal';
import { Storage } from '@/enums/storage.enum';
import { isNullable } from '@/utils/isNullable';

// Mixin filtrów raportów
export const reportFiltersMixin = {
  components: { FiltersModal },
  data() {
    const availableFilters = JSON.parse(this.$store.state.setting.settings.REPORT_FILTERS.value);

    return {
      filters: this.getFilters(availableFilters),
      showFiltersModal: false
    };
  },

  computed: {
    procedureId() {
      return this.$route.params.procedureId.toString();
    }
  },

  methods: {
    // @vuese
    // Zwraca listę wybranych filtrów
    getFilters(availableFilters) {
      const storageFiltersJSON = sessionStorage.getItem(
        Storage.REPORT_FILTERS + this.$route.params.procedureId.toString()
      );
      if (storageFiltersJSON) {
        const storageFilters = JSON.parse(storageFiltersJSON);
        return availableFilters.map(filter => {
          const storageFilterMatch = storageFilters.filter(storageFilter => storageFilter.name === filter.name);
          const storageFilterExactMatch =
            storageFilterMatch.length === 1
              ? storageFilterMatch[0]
              : storageFilterMatch.find(storageFilter => storageFilter.title === filter.title);

          if (!isNullable(storageFilterExactMatch?.value)) {
            filter.value = storageFilterExactMatch.value;
          } else if (isNullable(filter.value)) {
            filter.value = null;
          }
          return filter;
        });
      }

      return availableFilters.map(filter => {
        if (isNullable(filter.value)) {
          filter.value = null;
        }
        return filter;
      });
    },

    // @vuese
    // Otwiera modala z filtrami
    openFiltersModal() {
      this.showFiltersModal = true;
    },

    // @vuese
    // Zapisuje filtry
    saveFilters(filters) {
      this.filters = filters;
      sessionStorage.setItem(Storage.REPORT_FILTERS + this.procedureId, JSON.stringify(this.filters));
      this.updateList();
      this.closeFiltersModal();
    },

    // @vuese
    // Zamyka modala z filtrami
    closeFiltersModal() {
      this.showFiltersModal = false;
    }
  }
};
